import PropTypes from "prop-types";
import { coin } from "src/assets";
import { tokens } from "src/design-system/tokens";
import GrDialog from "src/design-system/components/GrDialog";
import CoinsUsersList from "./CoinsUsersList";
import { PEOPLE_DIALOG_WIDTH } from "./UsersList";

// "Shared Coins" popup of a post: who sent coins (`feeds_list.feed_points`), how many and their comment.
// Callers also pass showTab, post_id and feeds_type; the popup has one list, so they are not needed.
export default function ShowCoinsMembers({
  openLikesModal,
  handleCloseSimpleBox,
  feeds_list,
}) {
  return (
    <GrDialog
      showClose
      open={Boolean(openLikesModal)}
      onClose={handleCloseSimpleBox}
      maxWidth={PEOPLE_DIALOG_WIDTH}
      title="Shared Coins"
      titleIcon={
        <img src={coin} alt="" width={tokens.icon.lg} height={tokens.icon.lg} />
      }
    >
      <CoinsUsersList feedActivity={feeds_list?.feed_points} />
    </GrDialog>
  );
}

ShowCoinsMembers.propTypes = {
  openLikesModal: PropTypes.bool,
  handleCloseSimpleBox: PropTypes.func.isRequired,
  feeds_list: PropTypes.object,
};
